import { SpeakingRate } from "../../voice/model/SpeakingRate";
import i18n from "../../../i18n";

export function getSpeakingRateValue(rate: SpeakingRate): number {
  switch (rate) {
    case SpeakingRate.slow:
      return 0.6;
    case SpeakingRate.normal:
      return 0.8;
    case SpeakingRate.fast:
      return 1.0;
  }
}

export function getSpeakingRateName(rate: SpeakingRate): string {
  switch (rate) {
    case SpeakingRate.slow:
      return i18n.t("VoiceSpekingRateSlowlyValue");
    case SpeakingRate.normal:
      return i18n.t("VoiceSpekingRateNormalValue");
    case SpeakingRate.fast:
      return i18n.t("VoiceSpekingRateFasterValue");
  }
}
